export const INQUIRY_OPTIONS = [
  { value: 'corporate_gifts', label: 'Regalos empresariales' },
  { value: 'wholesale', label: 'Ventas por mayor' },
  { value: 'custom_branding', label: 'Personalización con logo' },
  { value: 'other', label: 'Otra consulta' },
] as const;

export const PRODUCT_OPTIONS = [
  { value: 'bottles_mugs', label: 'Botellas y mugs' },
  { value: 'backpacks_bags', label: 'Mochilas y bolsos' },
  { value: 'notebooks_agendas', label: 'Cuadernos y agendas' },
  { value: 'grill', label: 'Parrilla' },
  { value: 'mate_accessories', label: 'Mates y afines' },
  { value: 'toiletry_bags', label: 'Neceseres' },
  { value: 'apparel_uniforms', label: 'Prendas y uniformes' },
  { value: 'other', label: 'Otro' },
] as const;

export const INQUIRY_VALUES = INQUIRY_OPTIONS.map(({ value }) => value) as [
  (typeof INQUIRY_OPTIONS)[number]['value'],
  ...(typeof INQUIRY_OPTIONS)[number]['value'][],
];

export const PRODUCT_VALUES = PRODUCT_OPTIONS.map(({ value }) => value) as [
  (typeof PRODUCT_OPTIONS)[number]['value'],
  ...(typeof PRODUCT_OPTIONS)[number]['value'][],
];
